import { render, staticRenderFns } from "./InformacoesManutencao.vue?vue&type=template&id=8817947e&scoped=true&"
import script from "./InformacoesManutencao.vue?vue&type=script&lang=js&"
export * from "./InformacoesManutencao.vue?vue&type=script&lang=js&"
import style0 from "./InformacoesManutencao.vue?vue&type=style&index=0&id=8817947e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8817947e",
  null
  
)

export default component.exports